const variantTypes = {
    SUCCESS: 'success',
    DANGER: 'danger',
};

export default variantTypes;
